/** =========================================================
 * Module: main-preloader.service.js
 * Main preloadder control
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .service('MainPreloader', MainPreloader);

  MainPreloader.$inject = [];

  function MainPreloader() {
    var factory = {};

    factory.show = function () {
      $('.main-preloader').fadeIn();
    };

    factory.hide = function () {
      $('.main-preloader').fadeOut();
    };

    return factory;
  }
})();
